import { render, staticRenderFns } from "./hospitalNo.vue?vue&type=template&id=3a9f2970&scoped=true"
import script from "./hospitalNo.vue?vue&type=script&lang=js"
export * from "./hospitalNo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9f2970",
  null
  
)

export default component.exports